import type {SupportedLanguage} from 'talptech-gis-components';

type Values = {
  trackUuid: string;
  jwtToken: string;
  lang?: SupportedLanguage;
};

const parseTrackScreenshotQueryParameters = (href: string): Values => {
  // Get this page's query parameters
  const searchParams = new URLSearchParams(new URL(href).search).entries();
  const {trackUuid, jwtToken, lang} = Object.fromEntries(searchParams);

  if (!trackUuid) {
    throw new Error('"trackUuid" GET parameter is mandatory');
  }

  if (!jwtToken) {
    throw new Error('"jwtToken" GET parameter is mandatory');
  }

  const values: Values = {
    trackUuid,
    jwtToken,
  };

  if (lang && (lang === 'es' || lang === 'en')) {
    values.lang = lang;
  }

  return values;
};

export default parseTrackScreenshotQueryParameters;
